import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import * as ngswal from "sweetalert";
import { Local } from 'protractor/built/driverProviders';
import { ApiMethod } from '../apimethods/api-method';
import { DataParam, customfunctions } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { EmpmetricsdisplayModel } from './Empmetrics-displaymodel';
import * as Highcharts from 'highcharts';
declare var $;


@Component({
  selector: 'app-Empmetrics-display',
  templateUrl: './Empmetrics-display.component.html',
  styleUrls: ['./Empmetrics-display.component.css']
})
export class EmpmetricsdisplayComponent implements OnChanges {

  modelItem = new EmpmetricsdisplayModel();
 
  @Input() data: any[] = [];
  @Input() chartTitle: string = 'Monthly Metrics Overview';
  @Input() groupBy: 'Department' | 'account' | 'BUHead' = 'Department';
  @Input() groupLabel: string = '#';

  Highcharts: typeof Highcharts = Highcharts;
  groupedData: {
    groupName: string;
    records: any[];
    chartOptions: Highcharts.Options;
  }[] = [];


  ngOnChanges(): void {
    if (!this.data?.length) return;

    const groupMap = new Map<string, any[]>();
    const groupField = this.groupBy || 'Overall';

    // Dynamic grouping (e.g., by Department, BUHead, etc.)
    if (this.data[0][groupField]) {
      this.data.forEach(item => {
        const key = item[groupField];
        if (!groupMap.has(key)) groupMap.set(key, []);
        groupMap.get(key)!.push(item);
      });
    } else {
      groupMap.set('Overall', this.data);
    }

    // Updated metric field names
    const metrics = ['Productivity', 'Occupancy', 'Attendance', 'Punctuality'];
    const colors = ['#aed9e0', '#ffb6b9', '#c1f0f6', '#d0f0c0'];

    this.groupedData = Array.from(groupMap.entries()).map(([groupName, records]) => {
      const months = Array.from(new Set(records.map(r => r.MonthName)));
      let colorIndex = 0;

      const series: Highcharts.SeriesLineOptions[] = metrics.map(metric => {
        const data = months.map(month => {
          const rec = records.find(r => r.MonthName === month);
          return rec ? rec[metric] : null;
        });

        return {
          name: metric + ' %',
          data,
          type: 'line',
          color: colors[colorIndex++ % colors.length]
        };
      });

      const chartOptions: Highcharts.Options = {
        chart: {
          type: 'line',
          backgroundColor: '#ffffff',
          style: { fontFamily: 'Segoe UI, Roboto, sans-serif' }
        },
        title: {
          text: `${groupName} - ${this.chartTitle}`,
          style: { fontSize: '18px', fontWeight: '600', color: '#333' }
        },
        xAxis: {
          categories: months,
          title: { text: 'Month' },
          labels: { style: { color: '#6e6e6e' } }
        },
        yAxis: {
          title: { text: 'Percentage (%)' },
          labels: { style: { color: '#6e6e6e' } },
          gridLineColor: '#eaeaea'
        },
        tooltip: {
          shared: true,
          valueSuffix: '%'
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          itemStyle: { fontWeight: '500' }
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              style: { fontSize: '11px', color: '#444' }
            },
            enableMouseTracking: true
          }
        },
        series
      };

      return { groupName, records, chartOptions };
    });
  }



  //formatMetricName(metric: string): string {
  //  return metric.replace('net', '').replace(/([A-Z])/g, ' $1').trim() + ' %';
  //}
  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <EmpmetricsdisplayModel>data["EmpmetricsdisplayPage"];



      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }


}

